import { axiosFactory, errorHandler } from "@/configs/axios";

export const fuelType = {
  api: () => {
    return axiosFactory()
      .auth.get(`fuels/cards/types/`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};


export const downloadTransactions = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `exports/fuels/transactions/${queryString ? "?" + queryString : ""}`;

    return axiosFactory({ type: 'blob' })
      .auth.get(url)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
export const fuelType_ = {
  api: () => {
    return axiosFactory()
      .auth.get(`fuels/types/`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const fuels = {
  api: () => {
    return axiosFactory()
      .auth.get(`fuels/cards/`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const fuelsType = {
  api: () => {
    return axiosFactory()
      .auth.get(`fuels/cards/types/`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const addFuel = {
  api: (payload) => {
    return axiosFactory()
      .auth.post("fuels/cards/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const editFuel = {
  api: (payload) => {
    return axiosFactory()
      .auth.put("fuels/cards/" + payload.id + "/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
export const getFuel = {
  api: (payload) => {
    return axiosFactory()
      .auth.get("fuels/cards/" + payload + "/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const removeFuel = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete("fuels/cards/" + payload + "/")
      .then((res) => {
        return true;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
//

export const fuelsQuotas = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `fuels/quotas/${queryString ? "?" + queryString : ""}`;

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const fuelsQuota = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`fuels/quotas/?fuel_card=` + payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        return false;
        // errorHandler(error);
      });
  },
};

export const addFuelQuotas = {
  api: (payload) => {
    return axiosFactory()
      .auth.post("fuels/quotas/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const editFuelQuotas = {
  api: (payload) => {
    return axiosFactory()
      .auth.put("fuels/quotas/" + payload.id + "/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
export const getFuelQuotas = {
  api: (payload) => {
    return axiosFactory()
      .auth.get("fuels/quotas/" + payload + "/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const removeFuelQuotas = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete("fuels/quotas/" + payload + "/")
      .then((res) => {
        return true;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const addTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.post("fuels/transactions/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const editTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.put("fuels/transactions/" + payload.id + "/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const addFreeTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.post("fuels/transactions/frees/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const getFreeTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.get("fuels/transactions/frees/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
export const getTransaction = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `fuels/transactions/${queryString ? "?" + queryString : ""}`;

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const removeTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete("fuels/transactions/" + payload + "/")
      .then((res) => {
        return true;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
export const removeFreeTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete("fuels/transactions/frees/" + payload + "/")
      .then((res) => {
        return true;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
